import { render, staticRenderFns } from "./TourTransfer.vue?vue&type=template&id=286a53d3"
import script from "./TourTransfer.vue?vue&type=script&lang=js"
export * from "./TourTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286a53d3')) {
      api.createRecord('286a53d3', component.options)
    } else {
      api.reload('286a53d3', component.options)
    }
    module.hot.accept("./TourTransfer.vue?vue&type=template&id=286a53d3", function () {
      api.rerender('286a53d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourTransfer.vue"
export default component.exports